import React from 'react';

const PageHeader = ({ eyebrow, title, description, action }) => (
  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
    <div>
      {eyebrow && (
        <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mb-1.5">{eyebrow}</p>
      )}
      <h1 className="text-3xl font-bold text-slate-900 tracking-tight">{title}</h1>
      {description && <p className="text-slate-500 text-sm mt-1">{description}</p>}
    </div>
    {action && <div className="flex-shrink-0">{action}</div>}
  </div>
);

export default PageHeader;